// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"SimpleVideo_videoContainer__aC2SO","video":"SimpleVideo_video__Wrdib","hidden":"SimpleVideo_hidden__O1jfL"};